import Application from "components/Application";
import withAppProviders from "hocs/withAppProviders";

export default withAppProviders({
  title: "Application",
  route: localStorage?.getItem("isLoggedIn") === true ? "/profile/back" : "/",
})(Application);
